import {match, Pattern} from 'ts-pattern';

import {FinancialProductUnavailableReason} from '../../api/types/onlineOfferTypes';

const UNAVAILABLE_REASON_LABEL_KEYS: Record<FinancialProductUnavailableReason, string> = {
  NOT_YET_VALID: 'financialProducts.unavailable.not_yet_valid',
  EXPIRED: 'financialProducts.unavailable.expired',
  ARCHIVED: 'financialProducts.unavailable.archived',
  DELETED: 'financialProducts.unavailable.deleted',
  MISSING_CONFIGURATION: 'financialProducts.unavailable.missing_configuration',
  MISSING_PROVIDER: 'financialProducts.unavailable.missing_provider',
  MISSING_VEHICLE_PRICE: 'financialProducts.unavailable.missing_vehicle_price',
  UNSUPPORTED_TERM: 'financialProducts.unavailable.unsupported_term',
  UNSUPPORTED_DOWN_PAYMENT: 'financialProducts.unavailable.unsupported_down_payment',
  UNSUPPORTED_BALLOON_PAYMENT: 'financialProducts.unavailable.unsupported_balloon_payment',
  UNSUPPORTED_TARGET_GROUP: 'financialProducts.unavailable.unsupported_target_group',
  MISSING_MATRIX_CELL: 'financialProducts.unavailable.missing_matrix_cell',
};

export const getFinancialProductUnavailableReasonLabelKey = (
  reason: FinancialProductUnavailableReason | null
) =>
  match(reason)
    .with(Pattern.nullish, () => 'financialProducts.unavailable.generic')
    .otherwise((unavailableReason) => UNAVAILABLE_REASON_LABEL_KEYS[unavailableReason]);
